import * as types from '../constants/actionTypes';
import LoopbackHttp from '../businessLogic/LoopbackHttp.js';

export function register(authOpts) {
  return (dispatch) => {
    LoopbackHttp.register(authOpts)
    .then(data => {
      dispatch({
        type: types.REGISTER_SUCCESS,
        data: data
      });
    })
    .catch((e) => {
      dispatch({
        type: types.REGISTER_FAILED,
        message: e.error.message
      });
    });
  };  
}

export function registerRequest() {
  return (dispatch) => {
    dispatch({
      type: types.REGISTER_REQUEST
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/registerFormActions.js